var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtmlDevelopmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 38,
    width: 24,
    height: 6,
    rx: 2,
    fill: "#FF873C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 43.8724L14.9568 44H13.5951C13.5928 44 13.5931 44 13.5908 44C13.5175 44 9 43.9724 9 36.7588C9 29.4861 12.3507 26.1178 12.3507 18.3858C12.3507 14.5317 11.5181 11.9393 10.683 10.3084C10.2511 9.46488 10.9255 8 11.8732 8H36.0153C36.2486 8 36.4728 8.08016 36.6324 8.25026C37.4159 9.08506 39.727 12.0919 39.727 18.5134C39.727 26.2454 36.3763 29.3841 36.3763 36.6567",
    stroke: "#030F3A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3654 39.7333C20.3654 41.44 18.1218 43.2889 17 44H39.1946C40.5143 44 41.6194 43.0001 41.7509 41.687C41.8896 40.3025 40.9009 39.0593 39.5208 38.8827L17 36C18.1218 36.5333 20.3654 38.0267 20.3654 39.7333Z",
    stroke: "#030F3A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4793 20.3782L17.6948 23.1627L20.4793 25.9471",
    stroke: "#030F3A",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6891 20.3782L33.4736 23.1627L30.6891 25.9471",
    stroke: "#030F3A",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2637 30.1239L28.3686 16.6655",
    stroke: "#030F3A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14C6.75462 15.1667 7.8111 18.8 6 24",
    stroke: "#030F3A",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlDevelopmentIcon);
export default __webpack_public_path__ + "static/media/html-development-icon.0f1f0edbc76b9f85e3677530de52905c.svg";
export { ForwardRef as ReactComponent };